import { isMobile, isTablet } from 'react-device-detect';
import { BASE_SLIDER_GAP } from '@24i/nxg-core-utils/src/constants';
import { getTelegramWebApp, getTelegramWebAppTopSafeAreaInset, calculateTelegramGap } from '@24i/nxg-sdk-higgs/src/utils';

export function getTelegramTopGap(): number {
    if (!getTelegramWebApp()) return 0;
    if (isTablet) return 0;
    if (isMobile) return getTelegramWebAppTopSafeAreaInset();

    const safeAreaInset = getTelegramWebAppTopSafeAreaInset();
    return calculateTelegramGap() + (safeAreaInset === 0 ? BASE_SLIDER_GAP : safeAreaInset);
}
